module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-EN.cbf0932.webp";